import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";

export default function AdminPanel() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔍 Kagua kama user aliye login ni admin
  useEffect(() => {
    const checkAdmin = async () => {
      const username = localStorage.getItem("username");
      if (!username) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const q = query(collection(db, "users"), where("username", "==", username));
        const snap = await getDocs(q);

        if (!snap.empty) {
          const data = snap.docs[0].data();
          setIsAdmin(data.role === "admin");
        } else {
          setIsAdmin(false);
        }
      } catch (err) {
        console.error("Error checking admin:", err);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };
    checkAdmin();
  }, []);

  // 📋 Pata list ya admins wote
  const fetchAdmins = async () => {
    const q = query(collection(db, "users"), where("role", "==", "admin"));
    const snap = await getDocs(q);
    setAdmins(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };

  // 📋 Pata list ya users wote
  const fetchUsers = async () => {
    const q = query(collection(db, "users"));
    const snap = await getDocs(q);
    setUsers(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };

  useEffect(() => {
    if (isAdmin) {
      fetchAdmins();
      fetchUsers();
    }
  }, [isAdmin]);

  // 🧩 Badilisha role
  const handleRoleChange = async (id, newRole) => {
    try {
      const userRef = doc(db, "users", id);
      await updateDoc(userRef, { role: newRole });
      alert(`Role imebadilishwa kuwa ${newRole}`);
      fetchAdmins();
      fetchUsers();
    } catch (err) {
      console.error("Error updating role:", err);
      alert("Imeshindikana kubadilisha role. Jaribu tena.");
    }
  };

  if (loading) return <p style={{ textAlign: "center" }}>Checking access...</p>;
  if (!isAdmin)
    return <p style={{ textAlign: "center", color: "red" }}>Huna ruhusa ya kufungua ukurasa huu.</p>;

  return (
    <div className="admin-panel">
      <h2>Admin Control Panel</h2>

      <section className="admins">
        <h3>✅ Wote wenye role ya Admin</h3>
        <ul>
          {admins.map((admin) => (
            <li key={admin.id}>
              {admin.username} — {admin.fullName}
              <button
                className="remove-btn"
                onClick={() => handleRoleChange(admin.id, "user")}
              >
                Ondoa Admin
              </button>
            </li>
          ))}
        </ul>
      </section>

      <section className="users">
        <h3>👥 Wote (Users & Admins)</h3>
        <ul>
          {users.map((user) => (
            <li key={user.id}>
              <strong>{user.username}</strong> — {user.role}
              {user.role !== "admin" && (
                <button
                  className="make-admin-btn"
                  onClick={() => handleRoleChange(user.id, "admin")}
                >
                  Mpa Admin
                </button>
              )}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}